export default "__VITE_ASSET__BMxCflJ___"